module.exports = [
  'common',
  'footer',
  'navbar',
  'navigation',
  'error',
  'banner',
  'content',
  'seo',
  'subject',
  'channel',
  'login',
  'app',
  'signup',
  'campaign',
  'quizzes',
  'dashboard',
  'home',
  'post',
  'onboarding',
];



// WEBPACK FOOTER //
// ./app/constants/i18ns.js